import { controls } from "../controls";

const sv301 = {
  label: "Scroll",
  starting: true,
  url: "sv301",
  pageLabel: "Share Withdraw Demand",
  pageType: "history",
  filter: [
    ...controls.displayText({ label: "Region", width: "col-sm-2" }),
    ...controls.Region(),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "region",
      textcolor: "black",
      name: "region_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },

    ...controls.displayText({ label: "Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isReadOnly: true, isRequired: true, star: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Regular",
          value: "Regular"
        },
        {
          label: "Associated",
          value: "Associated"
        },
        {
          label: "Nominal(B Class)",
          value: "Nominal(B Class)"
        },

      ],
      placeHolder: "Member Type",
      name: "MemberType",
      description: "Enter Member Type"
    },


    ...controls.magicDateLabel({ tab: "filter", label: "", width: "col-sm-8" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Request From-To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "from_date", width: "col-sm-2", default: "30660000000 ago" }),

    ...controls.magicDateLabel({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "to_date", width: "col-sm-2", default: "n" }),

    ...controls.magicDateLabel({ tab: "filter", label: "", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "# Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", defaultValue: 10, name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", default: true, label: "Active", name: "isActive", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
  ],

  form: [
    {
      widths: "col-sm-10",
      tab: "create",
      style: { border: 0, paddingTop: 0 },
      subComponents: [
        {
          widths: "col-sm-12",
          tab: "create",
          title: "Create Share Withdraw Demand",
          subComponents: [
            ...controls.displayText({ tab: "filter", width: "col-sm-0" }),
            ...controls.displayText({ tab: "filter", star: true, label: "Member Type", width: "col-sm-2" }),
            {
              inputType: "select",
              default: "",
              widths: {
                parent: "col-sm-2",
                children: "col-sm-12"
              },
              options: [
                {
                  label: "Regular",
                  value: "Regular"
                },
                {
                  label: "Associated",
                  value: "Associated"
                },
                {
                  label: "Nominal(B Class)",
                  value: "Nominal(B Class)"
                },

              ],
              placeHolder: "Member Type",
              name: "MemberType",
              description: "Enter Member Type"
            },

            ...controls.displayText({ tab: "create", label: "", width: "col-sm-8" }),

            ...controls.displayText({ tab: "create", label: "Member No", width: "col-sm-2" }),
            ...controls.text({ tab: "create", name: "member_no", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", label: "", width: "col-sm-8" }),

            ...controls.displayText({ tab: "create", label: "No of Shares", width: "col-sm-2" }),
            ...controls.text({ tab: "create", name: "no_of_shares", width: "col-sm-4" }),


            ...controls.displayText({ tab: "create", star: true, label: "Amount", width: "col-sm-2" }),
            ...controls.text({ tab: "create", name: "amount", width: "col-sm-4" }),


            ...controls.magicDateLabel({ tab: "filter", label: "Request Date", width: "col-sm-2" }),
            ...controls.magicDate({ isReadOnly: true, name: "request_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

            ...controls.displayText({ tab: "create", label: "", width: "col-sm-8" }),
            ...controls.displayText({ tab: "create", label: "Reason", width: "col-sm-2" }),
            ...controls.text({ tab: "create", name: "reason", width: "col-sm-4" }),

            ...controls.displayText({ tab: "create", label: "", width: "col-sm-6" }),
            ...controls.displayText({ tab: "create", star: true, label: "Parent Branch", width: "col-sm-2" }),
            ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, defaultValue: "assigned_branch" }),
            ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", width: "col-sm-5" }),

            ...controls.displayText({ tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2" }),
            ...controls.product({
              tab: "create", isRequired: true, width: "col-sm-2",
              sendToServer: { dataType: 'product', sendData: [{ varname: 'lastAcNo', fixed: true }, { varname: 'branch_guid', value: 'branch_guid' }] },
              clearData: ['customer_number', 'account_type', 'mode_of_operation'],
              displayData: { descn: "product_code_display", guid: "product_code_guid", producttype: "product_type" }
            }),

            ...controls.showData({ tab: "create", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", label: "", width: "col-sm-6" }),

            ...controls.displayText({ tab: "create", star: true, label: "Account No.", width: "col-sm-2" }),
            ...controls.text({ tab: "create", name: "ac_no", width: "col-sm-4" }),
            ...controls.displayText({ tab: "create", label: "", width: "col-sm-6" }),

            ...controls.displayText({ tab: "create", label: "Posted-Recno", width: "col-sm-2" }),
            ...controls.text({ tab: "create", name: "posted-recno", width: "col-sm-4" }),
            ...controls.displayText({ tab: "create", label: "", width: "col-sm-6" }),

          ]
        }]
    }],



  history: {
    perPage: 10,
    reportHeader: "Share Withdraw Demand",
    clickable: false,

    displayColumns: [
      {
        Header: "Edit",
        accessor: "edit",
        width: 150
      },
      {
        Header: "Delete",
        accessor: "delete",
        width: 150
      },
      {
        Header: "View",
        accessor: "view",
        width: 150
      },
      {
        Header: "No",
        accessor: "no",
        width: 150
      },
      {
        Header: "Date",
        accessor: "date",
        width: 150
      },
      {
        Header: "Member Type",
        accessor: "member_type",
        width: 150
      },

      {
        Header: "Member-No",
        accessor: "member_no",
        width: 150
      },

      {
        Header: "Name",
        accessor: "full_name",
        width: 150
      },

      {
        Header: "A/c Number",
        accessor: "ac_number",
        width: 150
      },

      {
        Header: "A/c Name",
        accessor: "ac_name",
        width: 150
      },
      {
        Header: "Active",
        accessor: "active",
        width: 150
      },
      {
        Header: "Post-No",
        accessor: "post_no",
        width: 150
      },
    ]
  }
};

export default sv301;